// VoiplyHeader — handoff v3 design.
//
// The handoff `.topbar` calls for:
//   • Warm white→orange-tinted gradient background
//     (linear-gradient(180deg, #fff 0%, #FFFBF8 100%))
//   • A thin orange hairline at the bottom plus a faint orange glow
//     a couple pixels under (decorative).
//   • Grid layout: logo + eyebrow on the left, optional center slot,
//     optional right slot. We don't use center/right on this app — the
//     entire flow has just the brand identifier — so those slots stay
//     empty and the layout still works.
//   • 26px logo height, a vertical divider before the eyebrow, and the
//     eyebrow reads "Customer testimonials" (handoff copy — was the
//     short "Testimonials" until this change).
//   • prefers-reduced-motion does nothing here; nothing animates.
//
// We keep an optional `progress` prop because it's harmless and we use
// it on the recorder flow to show upload progress at the top edge. The
// progress bar sits OUTSIDE the gradient so it doesn't fight the orange
// glow underneath.

export default function VoiplyHeader({ progress = null }) {
  return (
    <header className="vt-topbar">
      <div className="vt-topbar-left">
        <a href="/" aria-label="Voiply">
          <img
            className="vt-topbar-logo"
            src="https://63b4b496a6f4b9b3afd358772c056add.cdn.bubble.io/f1753191012861x650931340984918900/Auto%20Layout%20Horizontal.svg"
            alt="Voiply"
            loading="eager"
            fetchPriority="high"
          />
        </a>
        <span className="vt-topbar-divider" aria-hidden="true" />
        <span className="vt-topbar-eyebrow">Customer testimonials</span>
      </div>
      <div className="vt-topbar-center" />
      <div className="vt-topbar-right" />
      {progress !== null && (
        <div className="vt-topbar-progress">
          <span style={{ width: `${Math.max(0, Math.min(100, progress))}%` }} />
        </div>
      )}
    </header>
  );
}
